var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-289 381 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-271.9 387.1c-4.4 0-7.9 3.5-7.9 7.9 0 1.7.5 3.2 1.4 4.5l-4.9 4.9 1.4 1.4 4.8-4.8c1.4 1.2 3.2 1.9 5.2 1.9 4.4 0 7.9-3.5 7.9-7.9s-3.5-7.9-7.9-7.9zm0 13.8c-3.3 0-5.9-2.6-5.9-5.9 0-3.3 2.6-5.9 5.9-5.9 3.3 0 5.9 2.6 5.9 5.9 0 3.3-2.6 5.9-5.9 5.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarSearch);
export default __webpack_public_path__ + "static/media/toolbar-search.84b50cec.svg";
export { ForwardRef as ReactComponent };